// extracted by mini-css-extract-plugin
module.exports = {"base":"pagination_base__2uzaa"};